import find from 'lodash/find';
import without from 'lodash/without';
import set from 'lodash/set';
import cloneDeep from 'lodash/cloneDeep';
import Vue from 'vue';

export const state = {
  processing: false,
  notifications: [],
  lockScroll: false,
  promiseArray: [],
  promiseCount: 0,
  ready: false,
  debounce: null,
  debouncing: false,
  previousDebounce: null,
};

export const mutations = {
  applicationReady(state, ready) {
    state.ready = ready;
  },

  addNotification(state, notification) {
    if (!find(state.notifications, n => n === notification)) {
      state.notifications = [...state.notifications, notification];
    }
  },

  removeNotification(state, notification) {
    state.notifications = without(state.notifications, notification);
  },

  lockScroll(state, isVisible) {
    state.lockScroll = isVisible;
    if (isVisible) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }
  },

  addPromise(state, promiseObj) {
    state.processing = true;
    state.promiseArray = [...state.promiseArray, promiseObj]
    state.promiseCount++;
  },

  removePromise(state, promiseObj) {
    state.promiseArray = without(state.promiseArray, promiseObj);
    state.processing = state.promiseArray.length > 0;
  },

  // universal method to update random item in a v-for
  updateState(state, { object, property, value }) {
    set(object, property, value);
  },

  updateStateClone(state, { object, property, value }) {
    set(object, property, cloneDeep(value));
  },

  // univseral method to set random item in a v-for where the property doesnt exist
  // use this method very carefully
  setState(state, { object, property, value }) {
    Vue.set(object, property, value);
  },
};